import {ChangeDetectorRef, Component, OnDestroy, OnInit, ElementRef, ViewChild} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {DatePipe} from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';
import {InsuranceService} from '../insurance.service';
import {Globals} from '../../../globals';
import {
    InsuranceCarriersSubscribersComponent
} from '../insurance-carriers-subscribers/insurance-carriers-subscribers.component';
import {
    InsuranceManageSubscribersComponent
} from '../insurance-manage-subscribers/insurance-manage-subscribers.component';
import {MessagingService} from '../../../services/messaging.service';
import {InsuranceCoverageComponent} from '../insurance-coverage/insurance-coverage.component';
import {InsuranceProfileComponent} from '../insurance-profile/insurance-profile.component';
import {StaticDataService} from '../../../services/static-data.service';
import {ContactDataModel} from '../../../models/person/contact-data.model';
import {PatientInsuranceDataModel} from '../../../models/patient/patient-insurance-data.model';
import {PatientDataModel} from '../../../models/patient/patient-data.model';
import {InsuranceRelationEnum} from '../../../models/enum/insurance-relation.enum';
import {MatRadioChange} from '@angular/material/radio';
import {PatientInsuranceListViewDataModel} from '../models/patient-insurance-list-view-data-view.model';
import {CdkDragDrop, CdkDropList, moveItemInArray} from '@angular/cdk/drag-drop';
import {DataARClaimModel} from '../../../models/accountsReceivable/data-ar-claim.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {UiService} from '../../../services/ui.service';
import {MatCheckboxChange} from '@angular/material/checkbox';

import {ConfirmComponent} from '../../../dialog/confirm-dialog/confirm.component';
import {InsuranceRtbDialogComponent} from '../insurance-rtb-dialog/insurance-rtb-dialog.component';
import {DentalXChangeRTBRequestModel} from '../../../models/accountsReceivable/dentalxchange-rtb-request.model';
import {ReportViewerDialogComponent} from '../../reports/report-viewer-dialog/report-viewer-dialog.component';
import {DialogService} from '../../../services/dialog.service';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {NotesService} from '../../../services/notes.service';
import {TdoNoteQueryModel} from '../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import {AuthenticationService} from '../../auth/services/authentication.service';
import {UserRoleEnum} from '../../../models/enum/user-role.enum';
import {ARService} from '../../ar/ar.service';
import {DataARClaimListModel} from '../../ar/models/data-ar-claim-list';
import {ClaimMethodEnum} from '../../../models/enum/notification/claim-method.enum';
import {NoteTypeEnum} from '../../../models/enum/note-type.enum';
import {NoteCategoryEnum} from '../../../models/enum/note-category.enum';
import {InsuranceDxCrossRefComponent} from '../insurance-dx-cross-ref/insurance-dx-cross-ref.component';

@Component({
    selector: 'app-insurance-management',
    templateUrl: './insurance-management.component.html',
    styleUrls: ['./insurance-management.component.scss']
})
export class InsuranceManagementComponent implements OnInit, OnDestroy {

    @ViewChild('insuranceYesNo') insuranceYesNo: ElementRef;

    dataPatient: PatientDataModel;
    cfgTDOClient: TdoClientConfigurationModel;

    dataPatientInsuranceList: PatientInsuranceListViewDataModel[];
    dataPatientInsuranceListDisplay: PatientInsuranceListViewDataModel[] = [];
    activeDataPatientInsurance: PatientInsuranceListViewDataModel;
    dataClaims: DataARClaimListModel[] = [];
    dataClaimsMaster: DataARClaimListModel[] = [];
    activeDataPatientInsuranceVisibleCount = 0;
    activeDataPatientInsuranceVisibleNum = 0;

    primaryPatientInsuranceID: string;
    secondaryPatientInsuranceID: string;

    activeDataPatientInsurancePrimary: string;
    activeDataPatientInsuranceCoverageStartDisplay: Date;
    activeDataPatientInsuranceCoverageEndDisplay: Date;
    activePatientInsuranceOrganizationID: string;
    activePatientInsuranceDescription: string;

    hideExpired: boolean = true;

    saveSubscriberContactSubscriber: any;
    saveDataPatientInsuranceSubscriber: any;
    messagingSubscription: any;
    currentPatientId: string = '';
    // relationshipEnums: EnumValidValueItemModel[] = [];
    loadNotes: boolean = true;
    isLoading: boolean = true;
    selectedRow: number = 0;
    tableData: PatientInsuranceDataModel[] = [];
    defaultCutoffDate: Date = new Date('1970-01-01T00:00:00');
    defaultDateISOString: Date = new Date('1900-01-01T00:00:00');
    defaultDate: Date = new Date('1901-01-01T00:00:00');
    currentDate: Date = new Date();
    patientHasNoInsurance: boolean = true;
    ClaimMethodEnumADAForm: string = '00000165-1000-0000-0000-000000000002';
    ClaimMethodEnumAPIDX: string = '00000165-1000-0000-0000-000000000001';
    isDentalExchangeConfiguredForLocation: boolean = false;

    constructor(
        public globals: Globals,
        private dialog: MatDialog,
        private insuranceService: InsuranceService,
        private arService: ARService,
        private snackBar: MatSnackBar,
        private messagingService: MessagingService,
        private datePipe: DatePipe,
        private staticDataService: StaticDataService,
        public uiService: UiService,
        private dialogService: DialogService,
        private notesService: NotesService,
        private changeDetectorRef: ChangeDetectorRef,
        private authenticationService: AuthenticationService
    ) {
    }

    resetData() {
        console.log('reset data');
        this.dataPatient = null;
        this.activeDataPatientInsurance = null;
        this.selectedRow = 0;
        this.tableData = [];
    }

    ngOnDestroy() {
        if (this.messagingSubscription)
        {this.messagingSubscription.unsubscribe(); }
    }

    async ngOnInit() {
        this.LoadInit();

    }
    async LoadInit() {
        // console.log('InsuranceManagementComponent load init ready: ', this.staticDataService.isReady);
        if (!this.staticDataService.isReady){
            setTimeout(() => {
                this.LoadInit();
            }, 200);
            return;
        }





        // check for messaging
        this.messagingSubscription = this.messagingService.componentMessageCall
            .subscribe(response => {
                const event = response.event;
                const eventData = response.data;

                if (event === MessagingConstants.PATIENT_CHANGED) {
                    this.currentPatientId = eventData.PatientId;
                    this.resetData();
                    this.initPage();
                }
            });

        // console.log('InsuranceManagementComponent getTDOClient');
        // get tdocid insurance related info
        this.insuranceService.getTDOClient()
            .subscribe(response => {
                // set results
                this.cfgTDOClient = response[0];
            }, err => {
                this.showMessage('Error', 'Error fetching tdo client details');
                this.isLoading = false;
            });
        // set insurance relationship enums
        if (this.globals.validTDOXpatientID) {
            this.currentPatientId = this.globals.validTDOXpatientID;

        } else {
            this.currentPatientId = this.globals.currentPatientId;
        }
        // console.log('InsuranceManagementComponent promises PatientID: ', this.currentPatientId);
        // get claims for patient
        const promises: any[] = [
            this.arService.getAllClaims().toPromise(),
            this.arService.getIsDentalExchangeConfiguredForLocation(parseInt(this.globals.LOCID)).toPromise(),
            this.arService.getClaimProcessorsForLocation(this.globals.LOCID).toPromise()
        ];
        const results: any[] = await Promise.all(promises);
        this.dataClaims = results[0];
        this.dataClaimsMaster = results[0];

        if (results[1] && results[1] === '1') {
            this.isDentalExchangeConfiguredForLocation = true;
        }
        // console.log('InsuranceManagementComponent initPage ');




        this.initPage();
    }

    initPage(keepIndex: boolean = false) {
        //
        // console.log('InsuranceManagementComponent initPage keepIndex: ', keepIndex);
        //
        this.isLoading = true;
        this.dataPatient = this.globals.ThePatient;
        this.patientHasNoInsurance = this.dataPatient?.isNoInsurance ?? true;
        // console.log('InsuranceManagementComponent initPage patientHasNoInsurance: ', this.patientHasNoInsurance);

        if (this.currentPatientId === undefined) {
            this.currentPatientId = this.dataPatient.PatientId;
        }


        // console.log('InsuranceManagementComponent initPage currentPatientId: ', this.currentPatientId);
        // get patient info from api
        this.insuranceService.getPatientInsuranceList(this.currentPatientId)
            .subscribe(response => {

                // console.log('InsuranceManagementComponent patient insurances', response);
                // set results
                this.isLoading = false;
                this.dataPatientInsuranceList = response;

                // if we have results...
                this.dataPatientInsuranceListDisplay = [];
                this.activeDataPatientInsuranceVisibleCount = 0;
                if (this.dataPatientInsuranceList.length > 0) {

                    // mark expired and inactive items
                    this.dataPatientInsuranceList.forEach(a => {
                        if (!a.isActive || this.isInsuranceExpired(a)) {
                            a.hideRow = true;
                        }
                        else {
                            this.activeDataPatientInsuranceVisibleCount++;
                            this.dataPatientInsuranceListDisplay.push(a);
                        }
                    });

                    // if we have a primary (non-default) active insurance, hide the default insurance
                    this.filterOutDefault();

                    this.setActiveDataPatientInsurance(this.dataPatientInsuranceList[this.selectedRow], this.selectedRow);

                } else {
                    // no insurance
                    this.setPatientInsuranceToDefault();
                    // this.patientHasNoInsurance = true;
                }
            }, err => {
                this.showMessage('Error', 'Error fetching patient insurance');
                this.isLoading = false;
            });
    }

    filterOutDefault() {
        if (this.dataPatientInsuranceList.length > 0) {
            if (!this.dataPatientInsuranceList[0].isDefault && this.dataPatientInsuranceList[0].isActive) {
                this.dataPatientInsuranceList = this.dataPatientInsuranceList.filter(a => a.isDefault === false);
            }
        }
    }

    saveCurrencyField(event, fieldName) {
        const inputValue = Number(event.target.value.replace(/[^0-9.-]+/g, ''));

        switch (fieldName) {
        case 'BenefitsMaximum': {
            this.activeDataPatientInsurance.BenefitsMaximum = inputValue;
            break;
        }
        case 'BenefitsLeft': {
            this.activeDataPatientInsurance.BenefitsLeft = inputValue;
            break;
        }
        case 'BenefitsDeductableLeftPreventitive': {
            this.activeDataPatientInsurance.BenefitsDeductableLeftPreventitive = inputValue;
            break;
        }
        case 'BenefitsDeductableLeftStandard': {
            this.activeDataPatientInsurance.BenefitsDeductableLeftStandard = inputValue;
            break;
        }
        case 'BenefitsDeductableLeftOther': {
            this.activeDataPatientInsurance.BenefitsDeductableLeftOther = inputValue;
            break;
        }
        case 'BenefitsDeductibleLeft': {
            this.activeDataPatientInsurance.BenefitsDeductibleLeft = inputValue;
            break;
        }
        }

        this.saveDataPatientInsurance(this.activeDataPatientInsurance);
    }

    selectRelationship(rel) {
        this.activeDataPatientInsurance.enumInsuranceRelationId = rel.ValidValueItemId;
        this.saveDataPatientInsurance(this.activeDataPatientInsurance);
    }

    saveSubscriberContact(dataContact: ContactDataModel) {

        if (this.saveSubscriberContactSubscriber) {
            this.saveSubscriberContactSubscriber.ubsubscribe();
            this.saveSubscriberContactSubscriber = false;
        }

        this.saveSubscriberContactSubscriber = this.insuranceService.saveSubscriberContact(dataContact)
            .subscribe(response => {
                this.saveSubscriberContactSubscriber = false;
            }, err => {
                this.saveSubscriberContactSubscriber = false;
            });
    }

    deleteDataPatientInsurance(dataPatientInsurance: PatientInsuranceDataModel) {
        this.saveDataPatientInsuranceSubscriber = this.insuranceService.deleteDataPatientInsurance(dataPatientInsurance)
            .subscribe(response => {
                this.saveDataPatientInsuranceSubscriber = false;

                // make sure selectedIndex is valid, for now just set it to 0
                this.selectedRow = 0;

                this.initPage(false);
            }, err => {
                this.saveDataPatientInsuranceSubscriber = false;
                // reject(err);
            });
    }

    setPatientInsuranceToDefault() {
        this.insuranceService.setPatientInsuranceToDefault(this.currentPatientId)
            .subscribe(response => {
                this.patientHasNoInsurance = true;
                this.dataPatientInsuranceList = [];
                this.dataPatientInsuranceList.push(response);
                this.setActiveDataPatientInsurance(response, 0);
            }, err => {

            });
    }

    saveDataPatientInsurance(dataPatientInsurance: PatientInsuranceDataModel) {
    // console.log("saveDataPatientInsurance", dataPatientInsurance);
        const promise = new Promise((resolve, reject) => {

            if (this.saveDataPatientInsuranceSubscriber) {
                this.saveDataPatientInsuranceSubscriber.unsubscribe();
                this.saveDataPatientInsuranceSubscriber = false;
            }

            this.saveDataPatientInsuranceSubscriber = this.insuranceService.updateDataPatientInsurance(dataPatientInsurance)
                .subscribe(response => {
                    this.saveDataPatientInsuranceSubscriber = false;
                    resolve(response);
                }, err => {
                    this.saveDataPatientInsuranceSubscriber = false;
                    reject(err);
                });
        });
        return promise;
    }

    saveDataPatientInsuranceWithoutSubscription(dataPatientInsurance: PatientInsuranceDataModel) {
        const promise = new Promise((resolve, reject) => {

            this.insuranceService.updateDataPatientInsurance(dataPatientInsurance)
                .subscribe(response => {
                    this.saveDataPatientInsuranceSubscriber = false;
                    resolve(response);
                }, err => {
                    this.saveDataPatientInsuranceSubscriber = false;
                    reject(err);
                });

        });
        return promise;
    }

    changePrimaryInsurance(eventChange: MatRadioChange) {

        if (eventChange.value === 'primary') {
            // change to primary
            this.selectedRow = 0;
            this.activeDataPatientInsurance.InsuranceOrder = 0;
            this.primaryPatientInsuranceID = this.activeDataPatientInsurance.PatientInsuranceID;
            this.orderInsuranceForPrimary();
            this.patientHasNoInsurance = false;
            this.savePatientIsNoInsurance();
        } else {
            this.filterOutDefault();

            // change to secondary
            this.orderInsuranceForSecondary();
        }

        // reorder display list
        this.dataPatientInsuranceList = this.dataPatientInsuranceList.sort((a, b) => a.InsuranceOrder - b.InsuranceOrder);

        this.filterOutDefault();
    }

    orderInsuranceForPrimary() {

        // loop through dataPatientInsuranceList
        // set order from 1 - x for all but the primary which gets set to 0
        let order = 0;
        this.dataPatientInsuranceList.forEach((insurance: PatientInsuranceListViewDataModel) => {
            if (insurance.PatientInsuranceID === this.activeDataPatientInsurance.PatientInsuranceID) {
                insurance.InsuranceOrder = 0;
            } else {
                insurance.InsuranceOrder = order + 1;
                order++;
            }

            // save insurance order change
            this.saveDataPatientInsuranceWithoutSubscription(insurance);
        });
    }

    orderInsuranceForSecondary() {

        // swap the order of the first two insurances
        if (this.dataPatientInsuranceList.length >= 2) {
            this.selectedRow = 1;
            this.dataPatientInsuranceList[0].InsuranceOrder = 1;
            this.dataPatientInsuranceList[1].InsuranceOrder = 0;
            this.activeDataPatientInsurance.InsuranceOrder = 1;

            // save insurance order change
            this.saveDataPatientInsuranceWithoutSubscription(this.dataPatientInsuranceList[0]);
            this.saveDataPatientInsuranceWithoutSubscription(this.dataPatientInsuranceList[1]);
        }
    }

    getPatientInsuranceList() {
        const promise = new Promise((resolve, reject) => {
            this.insuranceService.getPatientInsuranceList(this.currentPatientId)
                .subscribe(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                });
        });
        return promise;
    }

    getCurrentPatientInsuranceInformation() {
        const promise = new Promise((resolve, reject) => {
            this.insuranceService.getPatientInsuranceInformation(this.currentPatientId)
                .subscribe(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                });
        });
        return promise;
    }

    mapDataInsurancesToTableData(dataPatient: PatientDataModel) {
        this.tableData = [];
        dataPatient.dataPatientInsurances.map(insurance => {
            this.tableData.push(insurance);
        });

        this.tableData = this.tableData.sort((a, b) => a.InsuranceOrder - b.InsuranceOrder);
    }

    markInsuranceAsActive() {
        this.activeDataPatientInsurance.CoverageEnd = new Date(this.defaultDate);
        this.saveDataPatientInsurance(this.activeDataPatientInsurance);
    }

    markInsuranceAsExpired() {
        this.activeDataPatientInsurance.CoverageEnd = new Date();
        this.saveDataPatientInsurance(this.activeDataPatientInsurance);
    }

    setActiveDataPatientInsurance(dataPatientInsurance: PatientInsuranceListViewDataModel, index: number) {

        console.log('setActiveDataPatientInsurance', dataPatientInsurance);
        // set fields derived from db.dataPatientInsurance
        this.activeDataPatientInsurance = dataPatientInsurance;
        this.activeDataPatientInsurancePrimary = index === 0 ? 'primary' : 'secondary';
        this.selectedRow = index;

        // these vars get sent to the coverages component
        this.activePatientInsuranceOrganizationID = dataPatientInsurance.OrganizationID;
        this.activePatientInsuranceDescription = dataPatientInsurance.Description;


        if (!this.isDateValid(this.activeDataPatientInsurance.CoverageStart)) {
            this.activeDataPatientInsurance.CoverageStart = null;
        }
        if (!this.isDateValid(this.activeDataPatientInsurance.CoverageEnd)) {
            this.activeDataPatientInsurance.CoverageEnd = null;
        }

        // load subscriber info
        if (this.activeDataPatientInsurance.SubsciberContactId) {
            this.insuranceService.getSubscriberContactByContactId(this.activeDataPatientInsurance.SubsciberContactId)
                .subscribe(response => {
                    this.activeDataPatientInsurance.SubscriberContact = response;
                }, err => {
                    // this.showMessage('Error', 'Error retrieving subscriber information');
                    // no subscriber
                });
        }

        const noteQueryModel = new TdoNoteQueryModel();
        noteQueryModel.parentObjectName = 'dataPatientInsurance';
        noteQueryModel.objectId = dataPatientInsurance.PatientInsuranceID;
        noteQueryModel.patientId = dataPatientInsurance.PatientId;
        noteQueryModel.categoryEnumId = NoteCategoryEnum.Insurance;
        noteQueryModel.typeEnumId = NoteTypeEnum.Patient;
        this.notesService.changeNoteQuery(noteQueryModel);

        // refresh claims window
        if (this.dataClaimsMaster && this.dataClaimsMaster.length > 0) {
            this.dataClaims = this.dataClaimsMaster.filter(a => a.PatientInsuranceID === dataPatientInsurance.PatientInsuranceID);
        } else {
            this.dataClaims = [];
        }
    }

    launchRTBResponseViewer() {

        const config = new MatDialogConfig();
        config.width = '617px';
        config.height = '745px';
        config.data = {
            PatientInsuranceID: this.activeDataPatientInsurance.PatientInsuranceID,
            ProviderDoctorID: this.globals.currentProviderDoctorID
        };
        config.panelClass = 'dialog';

        const rtbViewer = this.dialog.open(InsuranceRtbDialogComponent, config);
    }

    onClickClearPatientFeeSched() {

        this.insuranceService.savePatientFeeScheduleOverWriteClear(this.currentPatientId).subscribe(res => {

            console.log(res);
            this.initPage(true);

        });

    }
    launchInsuranceProfileSettings() {


        const dialogRef = this.dialog.open(InsuranceProfileComponent, {
            width: '600px',
            height: '400px',
            data: {
                PatientInsuranceID: this.activeDataPatientInsurance.PatientInsuranceID
            }
        });
        dialogRef.afterClosed().subscribe(
            result => {
                this.initPage(true);
            },
            err => {
                this.initPage();
            }
        );
    }

    launchSubscriberManager() {
        const config = new MatDialogConfig();
        config.width = '800px';
        config.height = '550px';
        config.data = {
            currentPatientId: this.currentPatientId,
            dataPatientInsurance: this.activeDataPatientInsurance,
            currentPatient: this.dataPatient,
        };
        config.panelClass = 'dialog';

        const dialogRef = this.dialog.open(InsuranceManageSubscribersComponent, config);
        dialogRef.afterClosed().subscribe(
            result => {

                if (result) {
                    if (result.relationship) {
                        this.activeDataPatientInsurance.enumInsuranceRelationId = result.relationship;
                    }

                    if (result.DOB) {
                        this.activeDataPatientInsurance.SubsciberBirthdate = result.DOB;
                    }
                }

                this.initPage(true);
            },
            err => {
                this.initPage();
            }
        );

    }

    launchCarrierManager() {
        const config = new MatDialogConfig();
        config.width = '800px';
        config.height = '830px';
        if (this.globals.validTDOXpatientID) {
            console.log('from referral');
            config.data = {
                dataPatientInsurance: this.activeDataPatientInsurance,
                dataPatientId: this.globals.validTDOXpatientID,
                dataPatient: this.globals.ThePatient
                // dataPatient: this.dataPatient
            };
        } else {
            config.data = {
                dataPatientInsurance: this.activeDataPatientInsurance,
                dataPatientId: this.globals.currentPatientId,
                dataPatient: this.globals.ThePatient
                // dataPatient: this.dataPatient
            };
        }
        config.panelClass = 'dialog';

        const dialogRef = this.dialog.open(InsuranceCarriersSubscribersComponent, config);
        dialogRef.afterClosed().subscribe(
            result => {
                this.initPage(true);
                this.patientHasNoInsurance = false;
            },
            err => {
                this.initPage();
            }
        );
    }

    launchCoverageManager() {
        const config = new MatDialogConfig();
        config.width = '1200px';
        config.height = '800px';
        config.data = {
            dataPatientInsurance: this.activeDataPatientInsurance,
            OrganizationID: this.activePatientInsuranceOrganizationID,
            Description: this.activePatientInsuranceDescription
        };
        config.panelClass = 'dialog';

        const dialogRef = this.dialog.open(InsuranceCoverageComponent, config);
        dialogRef.afterClosed().subscribe(
            result => {
                if (result) {
                    // this.initPage(true);
                } else {
                    // this.initPage(false);
                }
            },
            err => {
                // this.initPage();
            }
        );
    }

    removeSelectedCarrier() {
        this.activeDataPatientInsurance.isActive = false;
        this.deleteDataPatientInsurance(this.activeDataPatientInsurance);
    }

    showMessage(type, message) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    dropListDropped(event: CdkDragDrop<PatientInsuranceListViewDataModel[]>) {
        moveItemInArray(this.dataPatientInsuranceList, event.previousIndex, event.currentIndex);
    }

    disablePage() {
        if (!this.activeDataPatientInsurance?.isActive || this.activeDataPatientInsurance?.isDefault) {
            return true;
        } else {
            return false;
        }
    }

    savePatientHasInsurance(event: boolean) {
        console.log('Changed to:', event);

        this.patientHasNoInsurance = null;

        if (event) {
            this.dialogService.openConfirmDialog('Proceeding will remove any existing insurance details for this patient. Are you sure that you want to continue?').subscribe((result) => {
                if (result === true) {
                    // set insurance to default
                    this.setPatientInsuranceToDefault();
                    this.patientHasNoInsurance = true;
                } else {
                    // don't do anything
                    this.patientHasNoInsurance = false;
                    this.changeDetectorRef.detectChanges();

                }

                this.savePatientIsNoInsurance();

            });
        }
        else
        {
            this.patientHasNoInsurance = false;
            this.savePatientIsNoInsurance();
        }


    }

    savePatientIsNoInsurance()
    {
        this.insuranceService.savePatientIsNoInsurance(this.currentPatientId, this.patientHasNoInsurance).subscribe(
            res => {
                console.log(res);

                this.dataPatient.isNoInsurance = this.patientHasNoInsurance;
                this.globals.ThePatient.isNoInsurance = this.patientHasNoInsurance;

                this.changeDetectorRef.detectChanges();

            });
    }

    isElementEnabled() {
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.Insurance);
    }

    async getAllClaims(InsuranceID: string) {

        const promises: any[] = [
            this.arService.getAllClaims().toPromise(),
        ];

        this.isLoading = true;

        const results: any[] = await Promise.all(promises);
        this.dataClaims = results[0];
    }

    isInsuranceExpired(insurance: PatientInsuranceListViewDataModel) {
        // console.log('InsuranceManagementComponent isInsuranceExpired', insurance);
        const covEnd = insurance.CoverageEnd ? new Date(insurance.CoverageEnd).toISOString() : '';
        const covToday = new Date(this.currentDate).toISOString();
        // const def = new Date(this.defaultDateISOString).toISOString();
        // console.log('InsuranceManagementComponent isInsuranceExpired covEnd: ', covEnd);
        // console.log('InsuranceManagementComponent isInsuranceExpired covToday: ', covToday);
        if (covEnd < covToday && covEnd && this.isDateValid(insurance.CoverageEnd)) {
            return true;
        }
        else { return false; }
    }

    isDateValid(d: Date) {
        if (d && new Date(d).toISOString() > new Date(this.defaultCutoffDate).toISOString()) {
            return true;
        }
        else {
            return false;
        }
    }

    hideShowNotActive() {
        // console.log('hideShowNotActive this.dataPatientInsuranceList: ', this.dataPatientInsuranceList);
        if (!this.dataPatientInsuranceList)
        { return; }
        if (this.hideExpired) {
            // mark all rows as visible
            this.dataPatientInsuranceList.forEach(a => {
                a.hideRow = false;
            });
            this.hideExpired = false;
        }
        else {
            // mark expired and inactive items
            this.dataPatientInsuranceList.forEach(a => {
                if (!a.isActive || this.isInsuranceExpired(a)) {
                    a.hideRow = true;
                }
            });
            this.hideExpired = true;
        }
    }


    launchDentalExchangeXRef() {
        console.log('launchDentalExchangeXRef');


        const dialogRef = this.dialog.open(InsuranceDxCrossRefComponent, {
            width: '700px',
            height: '600px',
            data: {
                mode: 'Relationship'
            }
        });
        dialogRef.afterClosed().subscribe(
            result => {

            },
            err => {

            }
        );

    }
}
